export default __webpack_public_path__ + "/dist/images/buyer-mockup.3707e8fffc76059035280a4c3dde1ab9.png";